import { render, staticRenderFns } from "./WizardOverviewPaper.vue?vue&type=template&id=320d75b6&scoped=true&"
import script from "./WizardOverviewPaper.vue?vue&type=script&lang=js&"
export * from "./WizardOverviewPaper.vue?vue&type=script&lang=js&"
import style0 from "./WizardOverviewPaper.vue?vue&type=style&index=0&id=320d75b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d75b6",
  null
  
)

export default component.exports